import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { types } from 'types/passengers';

const PassengerType = ({ type, disabilityType, isABSOrAdsAccessibleTravel = false }) => {
  if (type === types.DOG) {
    return <FormattedMessage id="passengerType.guideDog" />;
  }

  if (disabilityType === types.WHEELCHAIR) {
    if (isABSOrAdsAccessibleTravel) {
      return type === types.CHILD ? <FormattedMessage id="passengerType.child" /> : <FormattedMessage id="passengerType.adult" />;
    }

    return <FormattedMessage id="passengerType.wheelchair" values={{ passengerType: type }} />;
  }

  if (disabilityType === types.EVAC) {
    return <FormattedMessage id="passengerType.evac" values={{ passengerType: type }} />;
  }

  if (disabilityType === types.COMPANION || disabilityType === types.NO_WHEELCHAIR_COMPANION) {
    if (isABSOrAdsAccessibleTravel) {
      return type === types.CHILD ? <FormattedMessage id="passengerType.child" /> : <FormattedMessage id="passengerType.adult" />;
    }

    return <FormattedMessage id="passengerType.companion" />;
  }

  if (type === types.CHILD) {
    return <FormattedMessage id="passengerType.child" />;
  }

  if (type === types.INFANT_IN_ARMS) {
    return <FormattedMessage id="passengerType.infantInArms" />;
  }

  if (type === types.INFANT_WITH_SEAT) {
    return <FormattedMessage id="passengerType.infantWithSeat" />;
  }

  if (type === types.INFANT_ONLY) {
    return <FormattedMessage id="passengerType.infant" />;
  }

  if (type === types.YOUTH) {
    return <FormattedMessage id="passengerType.youth" />;
  }

  if (type === types.SENIOR) {
    return <FormattedMessage id="passengerType.senior" />;
  }

  return <FormattedMessage id="passengerType.adult" />;
};

PassengerType.propTypes = {
  type: PropTypes.string.isRequired,
  disabilityType: PropTypes.string,
  isABSOrAdsAccessibleTravel: PropTypes.bool
};

export default PassengerType;
